import { Injectable } from '@angular/core';
import { DomainConfig } from '../../config/domain.config';
import { HttpService } from '../http.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CorporateService {
  private CORPORATE_BALANCE: any = null;
  constructor(private http: HttpService) { }

  isCorporateUser(): boolean {
    return DomainConfig.isCorporate === true;
  }

  isCorporateBalanceUser(): Observable<any>  {
    if (this.CORPORATE_BALANCE) {
      return of(this.CORPORATE_BALANCE);
    }
    return this.http.flightsave(`apiCorporateV2/user/user-meta`, '').pipe (
      map((res: any) => {
        if (res.statusCode === 200) {
          this.CORPORATE_BALANCE = res.data;
          return this.CORPORATE_BALANCE;
        } else {
          throw new Error('Failed to fetch Corporate Balance');
        }
      }),
      catchError(err => of(err))
    )
  }

  companies = [
    {
      active: true,
      country_key: "india",
      country_name: "India",
      country_code: "IN",
      isd_code: "+91",
      company_name: "Belair Ticket Center",
      company_address: "Plot No. 9, Sector 11, Dwarka, Delhi, India 110075",
      company_mobile: "+91-9355019962",
      company_email: "hdq@belair.in",
      main_website: "www.belair.in",
      website_url: "https://www.belair.in"
    },
    {
      active: true,
      country_key: "united_kingdom",
      country_name: "United Kingdom",
      country_code: "UK",
      isd_code: "+44",
      company_name: "Belair Travel Limited",
      company_address: "8th Floor Becket House, 36 Old Jewry, London, EC2R 8DD",
      company_mobile: "+44 0000000000",
      company_email: "support.uk@belair.com"
    },
    {
      active: true,
      country_key: "states_america",
      country_name: "United States of America",
      country_code: "USA",
      isd_code: "+1",
      company_name: "Belair Travel USA INC",
      company_address: "99 Wall Street #3070, New York, NY 10005",
      company_mobile: "+1 0000000000",
      company_email: "support.usa@belair.com"
    },
    {
      active: false,
      country_key: "singapore",
      country_name: "Singapore",
      country_code: "SG",
      isd_code: "+65",
      company_name: "Belair Travel Singapore Pte. Ltd",
      company_address: "16 Raffles Quay #09-01, Hong Leon Building, Singapore 048581",
      company_mobile: "+65 0000000000",
      company_email: "support.singapore@belair.com"
    }
  ]
}
